import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthService } from '@core/auth/auth.service';
import jwt_decode from 'jwt-decode';
import { Router } from '@angular/router';
import { ThemeService } from './shared/services/themeservice';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  roles:string[]=[
    "read:prospective",    
    "read:certification" 
  ];
  showLoading:boolean=false;
  ReadApr:boolean=false;
  ReadCertification:boolean=false;
  ReadReports:boolean=false;
  ReadMaintenance:boolean=false;
  ReadStudentSearch:boolean=false;
  ReadSummary:boolean=false;
  ReadDocuments:boolean=false;
  current: Observable<any>;
  constructor(private permissionsService: NgxPermissionsService, 
    public auth: AuthService,private router: Router,public themeService:ThemeService) {
       auth.loader$.subscribe((resp)=>{
        this.showLoading =resp;
      });
    }
    ngOnInit() {
      this.auth.getTokenSilently$().
      subscribe(
        token => {
          if (token != null) {
            var profile= jwt_decode(token);
            
            const permissions = profile["permissions"] || [];
            const roles = profile["https://investedenterprise.com/claims/roles"] || [];
            
            // Merge permissions and roles
            const allPermissions = [...permissions, ...roles];
        
            this.permissionsService.loadPermissions(allPermissions);

            this.getPermission();  
            if(profile["permissions"].length==0){
                this.router.navigate(['/profile']); 
            }
           }
        }
      );
      this.current=this.themeService.isTheme;  
    }

    getPermission() {      
      this.permissionsService.hasPermission("read:apr").then(data=>{
          this.ReadApr=data;
      }); 
      this.permissionsService.hasPermission("read:certification").then(data=>{
        this.ReadCertification=data;
      }); 
      this.permissionsService.hasPermission("read:reports").then(data=>{
        this.ReadReports=data;
      }); 
      this.permissionsService.hasPermission("read:maintenance").then(data=>{
        this.ReadMaintenance=data;
      });
      this.permissionsService.hasPermission("read:studentsearch").then(data=>{
        this.ReadStudentSearch=data;
      });
      this.permissionsService.hasPermission("read:summary").then(data=>{
        this.ReadSummary=data;
      });
      this.permissionsService.hasPermission("read:documents").then(data=>{
        this.ReadDocuments=data;
      });
    }
}
